import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, slice } from 'lodash';

import SuggestionListItem from 'commons-forms/components/InputAutoComplete/SuggestionList/SuggestionListItem.jsx';

import 'commons-forms/components/InputAutoComplete/SuggestionList/SuggestionList.scss';

class SuggestionList extends Component {
    shouldComponentUpdate(nextProps) {
        const { items, activeElementIndex } = this.props;
        return !isEqual(nextProps.items, items) || nextProps.activeElementIndex !== activeElementIndex;
    }

    render() {
        const { activeElementIndex, items, onSelectedOption, suggestionsToDisplay } = this.props;

        const suggestionItems = slice(items, 0, suggestionsToDisplay).map((item, index) => {
            return (
                <SuggestionListItem
                    key={item.value}
                    value={item.value}
                    isActive={index === activeElementIndex}
                    onItemClick={onSelectedOption}
                />
            );
        });

        return <ul className="SuggestionList">{suggestionItems}</ul>;
    }
}

SuggestionList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }).isRequired
    ).isRequired,
    onSelectedOption: PropTypes.func.isRequired,
    activeElementIndex: PropTypes.number.isRequired,
    suggestionsToDisplay: PropTypes.number.isRequired,
};

SuggestionList.displayName = 'SuggestionList';

export default SuggestionList;
